import { render, staticRenderFns } from "./bucketNames.vue?vue&type=template&id=5427b1f5&scoped=true&"
import script from "./bucketNames.vue?vue&type=script&lang=js&"
export * from "./bucketNames.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5427b1f5",
  null
  
)

export default component.exports